import { render, staticRenderFns } from "./CircleGradient.vue?vue&type=template&id=890807f6&scoped=true&"
import script from "./CircleGradient.vue?vue&type=script&lang=js&"
export * from "./CircleGradient.vue?vue&type=script&lang=js&"
import style0 from "./CircleGradient.vue?vue&type=style&index=0&id=890807f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890807f6",
  null
  
)

export default component.exports